import React from "react";
import "./style.css";
import Header2 from "./Components/Header2";
import Team2 from "./Components/Team2";
import Footer2 from "./Components/Footer2";
import Services2demo from "./Components/Services2demo";
import OurWork2 from "./Components/OurWork2";
import Achievement from "./Components/Achievement";
import Appointment from "./Components/Appointment";
import partner1 from "./Images/partner-1.jpg";
import partner2 from "./Images/partner-2.jpg";
import partner3 from "./Images/partner-3.jpg";
import partner4 from "./Images/partner-4.jpg";
import "./Components/flaticon.css";
import Welcome2 from "./Components/Welcome2";
import Testimonial from "./Components/Testimonial";
import Gallery from "./Components/Gallery";
import Offer from "./Components/Offer";
import Loader from "./Components/Loader";
import PopOffer from "./Components/Popoffer";

const Demotheme=()=>{
    return(
        <>
            <Header2/>
                <Welcome2/>
                <Services2demo/>
                <Team2/>
                <OurWork2/>
            <Footer2/>
        </>
    );
}

export default Demotheme;